import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import { TripService } from '../../providers/trip-service/trip-service';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { NavController } from 'ionic-angular';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
import { sample } from '@turf/turf';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';

@Component({
  selector: 'confirm-route-stop-card',
  templateUrl: 'confirm-route-stop-card.html',
})
export class ConfirmRouteStopCardComponent {
  log = debug('app:ConfirmRouteStopCardComponent');
  @Input() place: any = {};
  @Input() index: -1;
  @Input() smallCards = false;
  @Input() display = false;
  @Input() clickable = true;
  @Input() distanceFrom;
  @Input() isActive = true;

  // used to prevent navigating to
  pauseClick = false;
  addingStop = false;
  stopAdded = false;
  trip: any = {};
  userLocation;
  fuelPrice = '$9.99';
  subs = [];
  inited = false;

  constructor(
    public tripService: TripService,
    public placeService: PlaceServiceProvider,
    public navController: NavController,
    public tools: ToolsProvider,
    public geolocation: GeolocationProvider
  ) {
    this.setCurrentTrip();
    this.updateStopAddedState();
  }

  ngOnInit() {}

  ngOnChanges() {
    if (!this.isActive || this.inited) {
      return;
    }
    this.inited = true;
    this.geolocation.getRecentPosition().then(
      res => {
        this.userLocation = {
          coordinates: [res.longitude, res.latitude],
        };
      },
      e => {
        this.log('error with geoloaition', e);
      }
    );

    if (this.tripService.isPlaceInWaypoints(this.place)) {
      this.stopAdded = true;
    } else {
      this.stopAdded = false;
    }

    this.subs.push(
      this.tools.on('addedWaypoint', place => {
        if (this.tripService.isPlaceInWaypoints(this.place)) {
          this.stopAdded = true;
        } else {
          this.stopAdded = false;
        }
      })
    );
    this.subs.push(
      this.tools.on('removedWaypoint', place => {
        if (this.tripService.isPlaceInWaypoints(this.place)) {
          this.stopAdded = true;
        } else {
          this.stopAdded = false;
        }
      })
    );
  }

  private setCurrentTrip() {
    this.trip = this.tripService.getDisplayedTrip();
  }

  private updateStopAddedState() {
    if (_.includes(_.get(this, 'trip.waypoints'), this.place)) {
      this.stopAdded = true;
    }
  }

  addStop() {
    this.addingStop = true;
    this.tripService.addPlaceStop(this.place);
    this.stopAdded = true;
    this.log('add stop: ', this.stopAdded);
  }

  removeStop() {
    this.addingStop = true;
    this.tripService.removePlaceStop(this.place);
    this.stopAdded = false;
    this.log('remove stop', this.stopAdded);
  }

  navigateToDetail() {
    this.log('nav to detail', this.place);
    if (!this.clickable) {
      return;
    }

    if (this.pauseClick) {
      return;
    }

    this.pauseClick = true;
    let opts: any = {
      disableNearbyPlaces: _.cloneDeep(_.get(this.place, 'nearbyPlace')),
    };
    setTimeout(() => {
      this.pauseClick = false;
      if (this.addingStop) {
        this.addingStop = false;
      } else {
        this.placeService.activeDetailIndex = this.index;

        this.log('navparams confirm card', opts);
        this.placeService.openStopDetailPageForPlace(
          _.get(this, 'place'),
          opts
        );
      }
    }, 250);
  }

  navigate() {
    this.clickable = false;
    this.log('will direct to stop');

    this.tripService.navigateToPlace(this.place);

    setTimeout(() => {
      this.clickable = true;
    }, 250);
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      try {
        s();
      } catch (e) {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm-route-stop-card/confirm-route-stop-card.ts